<div class="banner-inactive-users" *ngIf="showBanner">
	<div class="banner-inactive-users-icon">
		<span class="freud-icon freud-icon-md freud-icon-bulb"></span>
	</div>
	<div class="banner-inactive-users-text">
		<span
			>{{ 'CONTACT.BANNER_INACTIVE_CLIENTS.TEXT_1' | translate }}
			{{ totalInactiveCustomers }}
			{{ 'CONTACT.BANNER_INACTIVE_CLIENTS.TEXT_2' | translate }}
		</span>
		<span (click)="sendMessage()" class="banner-inactive-users-button">{{
			'CONTACT.BANNER_INACTIVE_CLIENTS.TEXT_3' | translate
		}}</span>
	</div>
	<div class="banner-inactive-users-close" (click)="closeBanner()">
		<span class="freud-icon freud-icon-md freud-icon-close"></span>
	</div>
</div>
<contact-bulk-message
	*ngIf="totalInactiveCustomers > 0"
	[visible]="sendMessagesModal"
	[selectedContacts]="inactiveContacts"
	[message]="inactiveMessage"
	(closeModal)="closeBulkMessageModal($event)"
	(onSendMessage)="setSendedMessageInLocalStorage($event)"
	type="inactive"
></contact-bulk-message>
